import { SystemIconType } from '@fiverr-private/icons';
import { white, grey_1200 } from '@fiverr-private/sass/helpers/index';
import { CloseButtonProps } from './types';

export const ICON_SIZES: { [key in Exclude<CloseButtonProps['size'], undefined>]: SystemIconType['size'] } = {
    xs: 12,
    md: 16,
};

export const ICON_COLORS = {
    light: white,
    dark: grey_1200,
};
